import { render, staticRenderFns } from "./LiquidityFlow.vue?vue&type=template&id=9ebc5fe4&scoped=true&"
import script from "./LiquidityFlow.vue?vue&type=script&lang=js&"
export * from "./LiquidityFlow.vue?vue&type=script&lang=js&"
import style0 from "./LiquidityFlow.vue?vue&type=style&index=0&id=9ebc5fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebc5fe4",
  null
  
)

export default component.exports